export const endpoints = {
  crm: {
    connector: {
      url: '/organization/connector/crm',
    },
    getAccountKeys: {
      url: '/organization/connector/crm/accountKeys',
    },
    getAccountInfo: {
      url: '/organization/connector/crm/accountInfo',
    },
  },
  auth: {
    signUp: {
      url: '/auth/signup',
    },
    resetPassword: {
      url: '/auth/reset',
    },
  },
  payments: {
    planInfo: {
      url: '/payment/plans/quota',
    },
  },
  amp: {
    base: {
      url: '/amp',
    },
    draft: {
      url: '/amp/draft',
    },
    byId: (id) => ({
      url: `/amp/${id}`,
    }),
    favorites: {
      url: '/amp/favorites',
    },
    templates: {
      url: '/amp/templates',
    },
    getInstallation: (id) => ({
      url: `/amp/${id}/getInstallation`,
    }),
    checkInstallation: (id) => ({
      url: `/amp/${id}/checkInstallation`,
    }),
    live: {
      url: '/amp/live',
    },
    addToFavorites: {
      url: '/amp/addToFavorites',
    },
    removeFromFavorites: {
      url: '/amp/removeFromFavorites',
    },
    published: (id) => ({
      url: `/amp/${id}/published`,
    }),
    copy: (id) => ({
      url: `/amp/${id}/copy`,
    }),
    uploadEDetail: (ampId) => ({
      url: ampId ? `/amp/e-detailer/upload?ampId=${ampId}` : `/amp/e-detailer/upload`,
    }),
    reimportSlides: (id) => ({
      url: `/amp/e-detailer/${id}/reimport`,
    }),
    generatePdf: (id) => ({
      url: `/amp/${id}/generatePdf`,
    }),
  },
  domain: {
    getDomains: (ampId) => ({
      url: `/amp/${ampId}/domain`,
    }),
    saveDomain: (ampId) => ({
      url: `/amp/${ampId}/domain`,
    }),
    updateDomain: (ampId, domainId) => ({
      url: `/amp/${ampId}/domain/${domainId}`,
    }),
    deleteDomain: (ampId, domainId) => ({
      url: `/amp/${ampId}/domain/${domainId}`,
    }),
    publish: (ampId) => ({
      url: `/amp/${ampId}/domain/publish`,
    }),
    checkDNS: (ampId, domainId) => ({
      url: `/amp/${ampId}/domain/${domainId}/verify`,
    }),
  },
  user: {
    profile: {
      url: '/user/profile',
    },
    changePassword: {
      url: '/user/changePassword',
    },
  },
  media: {
    base: (ampId) => ({
      url: `/amp/${ampId}/media`,
    }),
    getAll: (ampId) => ({
      url: `/amp/${ampId}/media/find`,
    }),
    delete: (ampId, fileId) => ({
      url: `/amp/${ampId}/media/${fileId}`,
    }),
  },
  organization: {
    base: {
      url: '/organization',
    },
    members: {
      url: '/organization/members',
    },
    invite: {
      url: '/organization/sendInvites',
    },
    transfer: {
      url: '/organization/transfer',
    },
  },
  payment: {
    billing: {
      url: '/payment/billing',
    },
    setup: {
      url: '/payment/setup',
    },
    checkout: {
      url: '/payment/checkout',
    },
    portal: {
      url: '/payment/portal',
    },
    plans: {
      url: '/payment/plans',
    },
    planById: (planId) => ({
      url: `/payment/plans/${planId}`,
    }),
    taxIds: {
      url: '/payment/taxIds',
    },
  },
  plugin: {
    base: {
      url: '/plugin',
    },
    byId: (id) => ({
      url: `/plugin/${id}`,
    }),
  },
  role: {
    base: {
      url: '/role',
    },
    getById: (id) => ({
      url: `/role/${id}`,
    }),
  },
  conversation: {
    conversationsByAmpId: (ampId) => ({
      url: `/amp/${ampId}/conversation`,
    }),
  },
  realtime: {
    requestToken: {
      url: '/realtime/requestToken',
      ensureOrganization: true,
    },
  },
  insights: {
    session: (id) => ({ url: `/amp/${id}/insights/session` }),
    export: (id) => ({ url: `/amp/${id}/insights/session/export` }),
    exportRaw: (id) => ({ url: `/amp/${id}/insights/session/exportRaw` }),
    generatePdf: (id) => ({ url: `/amp/${id}/insights/session/generatePdf` }),
  },
};
